import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import { action, runInAction, makeObservable } from "mobx";
import JulianDate from "terriajs-cesium/Source/Core/JulianDate";
import Resource from "terriajs-cesium/Source/Core/Resource";
import ConstantProperty from "terriajs-cesium/Source/DataSources/ConstantProperty";
import PropertyBag from "terriajs-cesium/Source/DataSources/PropertyBag";
import isDefined from "../Core/isDefined";
import loadJson from "../Core/loadJson";
import proxyCatalogItemUrl from "../Models/Catalog/proxyCatalogItemUrl";
import { generateCesiumInfoHTMLFromProperties } from "../ReactViews/FeatureInfo/generateCesiumInfoHTMLFromProperties";
import MappableMixin from "./MappableMixin";
import TimeVarying from "./TimeVarying";
function FeatureInfoUrlTemplateMixin(Base) {
  var _class;
  let FeatureInfoUrlTemplateMixin = (_class = class FeatureInfoUrlTemplateMixin extends Base {
    constructor() {
      super(...arguments);
      makeObservable(this);
    }
    get hasFeatureInfoUrlTemplateMixin() {
      return true;
    }
    /**
     * Returns a {@link Feature} for the pick result.
     */

    /**
     * Returns a {@link Feature} for the pick result. If `featureInfoUrlTemplate` is set,
     * it asynchronously loads additional info from the url.
     */
    async getFeaturesFromPickResult(screenPosition, pickResult) {
      let loadExternal = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      const feature = await this.buildFeatureFromPickResult(screenPosition, pickResult);
      if (isDefined(feature)) {
        feature._catalogItem = this;
        feature.loadingFeatureInfoUrl = true;
        (async () => {
          if (loadExternal && isDefined(this.featureInfoUrlTemplate)) {
            const resource = new Resource({
              url: proxyCatalogItemUrl(this, this.featureInfoUrlTemplate, "0d"),
              templateValues: feature.properties ? feature.properties.getValue(new JulianDate()) : undefined
            });
            try {
              var _ref;
              const featureInfo = await loadJson(resource);
              Object.keys(featureInfo).forEach(property => {
                if (!feature.properties) {
                  feature.properties = new PropertyBag();
                }
                feature.properties.addProperty(property, featureInfo[property]);
              });
              // Update description of the feature after it is resolved from
              // feature info template url
              feature.description = new ConstantProperty(generateCesiumInfoHTMLFromProperties(feature.properties, (_ref = TimeVarying.is(this) ? this.currentTimeAsJulianDate : undefined) !== null && _ref !== void 0 ? _ref : JulianDate.now(), MappableMixin.isMixedInto(this) ? this.showStringIfPropertyValueIsNull : undefined));
            } catch (_e) {
              if (!feature.properties) {
                feature.properties = new PropertyBag();
              }
              feature.properties.addProperty("Error", "Unable to retrieve feature details from:\n\n" + resource.url);
            }
          }
          runInAction(() => feature.loadingFeatureInfoUrl = false);
        })();
      }
      return feature;
    }
    wrapImageryPickFeatures(imageryProvider) {
      const realPickFeatures = imageryProvider.pickFeatures;

      // Get CatalogItem properties, so we aren't reading them outside of a reaction
      const featureInfoUrlTemplate = this.featureInfoUrlTemplate;
      const proxiedFeatureInfoUrl = proxyCatalogItemUrl(this, featureInfoUrlTemplate !== null && featureInfoUrlTemplate !== void 0 ? featureInfoUrlTemplate : "", "0d");
      const showStringIfPropertyValueIsNull = MappableMixin.isMixedInto(this) ? this.showStringIfPropertyValueIsNull : undefined;
      const maxRequests = this.maxRequests;
      const currentTime = TimeVarying.is(this) ? this.currentTimeAsJulianDate : undefined;
      imageryProvider.pickFeatures = async (x, y, level, longitude, latitude) => {
        const features = await realPickFeatures.call(imageryProvider, x, y, level, longitude, latitude);
        if (isDefined(featureInfoUrlTemplate) && isDefined(features) && features.length < maxRequests) {
          for (let i = 0; i < features.length; i++) {
            const feature = features[i];
            const resource = new Resource({
              url: proxiedFeatureInfoUrl,
              templateValues: feature.properties ? feature.properties : undefined
            });
            try {
              const featureInfo = await loadJson(resource);
              Object.keys(featureInfo).forEach(property => {
                if (!feature.properties) {
                  feature.properties = {};
                }
                if (feature.properties instanceof PropertyBag) {
                  feature.properties.addProperty(property, featureInfo[property]);
                } else {
                  feature.properties[property] = featureInfo[property];
                }
              });
              // Update description of the feature after it is resolved from
              // feature info template url
              feature.description = generateCesiumInfoHTMLFromProperties(feature.properties, currentTime !== null && currentTime !== void 0 ? currentTime : JulianDate.now(), showStringIfPropertyValueIsNull);
            } catch (_e) {
              if (!feature.properties) {
                feature.properties = {};
              }
              feature.properties["Error"] = "Unable to retrieve feature details from:\n\n" + resource.url;
            }
          }
        }
        return Promise.resolve(features);
      };
      return imageryProvider;
    }
  }, _applyDecoratedDescriptor(_class.prototype, "getFeaturesFromPickResult", [action], Object.getOwnPropertyDescriptor(_class.prototype, "getFeaturesFromPickResult"), _class.prototype), _class);
  return FeatureInfoUrlTemplateMixin;
}
(function (_FeatureInfoUrlTemplateMixin) {
  function isMixedInto(model) {
    return model && model.hasFeatureInfoUrlTemplateMixin;
  }
  _FeatureInfoUrlTemplateMixin.isMixedInto = isMixedInto;
})(FeatureInfoUrlTemplateMixin || (FeatureInfoUrlTemplateMixin = {}));
export default FeatureInfoUrlTemplateMixin;